import { Component } from '@angular/core';
import { ApiService } from '../shared/api.service';

@Component({
  selector: 'my-home',
  template: require('./home.component.html'),
  styles: [require('./home.component.scss')]
})
export class HomeComponent {
  public people;
  public filter = {
    all: true,
    engineering: false,
    data: false,
    product: false,
    design: false,
    marketing: false,
    happiness: false,
    hr: false
  };

  constructor(private apiService: ApiService) {
    apiService.getPeople()
      .subscribe(
        people => this.people = people,
        error => console.error('Error: ' + error)
      );
  }

  public getImageUrl(person) {
    let firstName = person.firstName ? person.firstName.replace(/ /g, '_') : '';
    let lastName = person.lastName ? person.lastName.replace(/ /g, '_') : '';
    let url = '/img/people/' + firstName + '_' + lastName + '.jpg';
    return url.toLowerCase();
  }

  public preventNone() {
    return this.filter.all && !this.anyDepartmentSelected();
  }

  public updateAll() {
    this.filter.engineering = false;
    this.filter.data = false;
    this.filter.product = false;
    this.filter.design = false;
    this.filter.marketing = false;
    this.filter.happiness = false;
    this.filter.hr = false;
  }

  public updateFilter() {
    this.filter.all = !this.anyDepartmentSelected();
  }

  public checkFilter(person) {
    return this.filter.all || this.filter[person.department.toLowerCase()];
  }

  private anyDepartmentSelected() {
    return this.filter.engineering || this.filter.data || this.filter.product || this.filter.design ||
      this.filter.marketing || this.filter.happiness || this.filter.hr;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/home/home.component.ts